// FR-AD7: the target user's browser lands here from the link `ops::start_impersonation`
// hands the operator (they pass it along out of band — Slack, a support ticket, however). One
// shot: consumes the token, receives session cookies for the target's own account, then hands
// off to the library. See auth::handlers::impersonate_consume's doc comment for why the
// session is minted here rather than by the operator up front.
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, ApiFail } from "../api/client";
import type { AuthResponse } from "../api/types";
import { useSession } from "../session";
import { AuthShell } from "../components/AuthShell";
import { Notice } from "../components/ui";

export default function ImpersonateConsumePage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const { setUser, refresh } = useSession();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setError("This link is missing its token.");
      return;
    }
    let cancelled = false;
    api<AuthResponse>("POST", "/auth/impersonate/consume", { token })
      .then(async (res) => {
        if (cancelled) return;
        setUser(res.user);
        await refresh();
        navigate("/orgs", { replace: true });
      })
      .catch((err) => {
        if (cancelled) return;
        setError(
          err instanceof ApiFail
            ? err.message
            : "Couldn't reach Grackle. Check your connection and try again.",
        );
      });
    return () => {
      cancelled = true;
    };
  }, [token, setUser, refresh, navigate]);

  return (
    <AuthShell title="Opening this account" subtitle="One moment…">
      {error ? <Notice tone="error">{error}</Notice> : <div />}
    </AuthShell>
  );
}
